.wrapper {
  container-type: inline-size;
}

.container {
  display: flex;
  flex-direction: row;
  gap: 1.6rem;
  padding: 1.6rem;
  margin: 0;
  overflow-x: auto;
  scroll-snap-type: x mandatory;

  &[data-zoom='4'],
  &[data-zoom='3'],
  &[data-zoom='2'],
  &[data-zoom='1'] {
    display: grid;
    grid-gap: 1.6rem;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: 1fr;
    overflow-x: hidden;
  }

  @container (width > 600px) {
    display: grid;
    grid-gap: 1.6rem;
    grid-template-columns: repeat(auto-fill, calc((100% - (2 * 0.8rem)) / 2));
    overflow-x: hidden;
  }

  @container (width > 960px) {
    &[data-zoom='6'] {
      grid-template-columns: repeat(auto-fill, calc((100% - (2 * 1.6rem)) / 3));
    }

    &[data-zoom='5'] {
      grid-template-columns: repeat(auto-fill, calc((100% - (2 * 2.4rem)) / 4));
    }

    // Starting from here, the cards should hide their details
    &[data-zoom='4'] {
      grid-template-columns: repeat(auto-fill, calc((100% - (2 * 3.2rem)) / 5));
    }

    &[data-zoom='3'] {
      grid-template-columns: repeat(auto-fill, calc((100% - (2 * 4rem)) / 6));
    }

    &[data-zoom='2'] {
      grid-template-columns: repeat(auto-fill, calc((100% - (2 * 4.8rem)) / 7));

      [data-photo-uploader] {
        > div {
          gap: 1.2rem;
          > div {
            margin: 0;
          }
        }

        span {
          display: none;
        }
      }
    }

    &[data-zoom='1'] {
      grid-template-columns: repeat(auto-fill, calc((100% - (2 * 5.6rem)) / 8));
      [data-photo-uploader] {
        > div {
          gap: 1.2rem;
          > div {
            margin: 0;
          }
        }

        span {
          display: none;
        }
      }
    }
  }

  @container (width > 1736px) {
    &[data-zoom='6'] {
      grid-template-columns: repeat(auto-fill, calc((100% - (2 * 2.4rem)) / 4));
    }

    &[data-zoom='5'] {
      grid-template-columns: repeat(auto-fill, calc((100% - (2 * 3.2rem)) / 5));
    }

    &[data-zoom='4'] {
      grid-template-columns: repeat(auto-fill, calc((100% - (2 * 4rem)) / 6));
    }

    // Starting from here, the cards should hide their details
    &[data-zoom='3'] {
      grid-template-columns: repeat(auto-fill, calc((100% - (2 * 4.8rem)) / 7));
    }

    &[data-zoom='2'] {
      grid-template-columns: repeat(auto-fill, calc((100% - (2 * 5.6rem)) / 8));
    }

    &[data-zoom='1'] {
      grid-template-columns: repeat(auto-fill, calc((100% - (2 * 6.4rem)) / 9));
    }
  }
}
